<template>
  <div id="app">
    <v-home />
  </div>
</template>

<script>
import Home from '@/views/Home.vue';

export default {
  name: 'App',
  components: {
    'v-home': Home,
  },
};
</script>
